import { Component, Injector, OnInit } from '@angular/core';
import { PricingsService } from '@services/entity/pricings.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { UsersService } from '@services/entity/users.service';
import { InvoicesService } from '@services/entity/invoices.service';
import { UserDto } from '@dto/userDto';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TransactionsService } from '@services/entity/transactions.service';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { CustomersService } from '@services/entity/customers.service';
import { PayoutStatementsService } from '@services/entity/payout-statements.service';
import { PayoutStatementTableData } from '@dto/payoutStatementTableData';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'payout-statements',
  templateUrl: './payout-statements.component.html',
  styleUrls: ['./payout-statements.component.scss'],
})
export class PayoutStatementsComponent implements OnInit {

  public className = 'PayoutStatementsComponent'

  public user: UserDto

  public isLoading: boolean = true
  public isOperator: boolean = false
  public isCustomer: boolean = false
  public isUser: boolean = false

  public scheduledPayoutDate: Date
  public payoutStatements: PayoutStatementTableData[] = []

  constructor(
    public tableFunctions: TableFunctionsService,
    public router: Router,
    public datePipe: DatePipe,
    public activatedRoute: ActivatedRoute,
    public transactionsService: TransactionsService,
    public usersService: UsersService,
    public payoutStatementsService: PayoutStatementsService,
    public customersService: CustomersService,
    public pricingsService: PricingsService,
    public invoicesService: InvoicesService,
    public authenticationService: AuthenticationService,
    public stripeInfosService: StripeInfosService,
    public toastService: ToastService,
    injector: Injector
  ) {
    this.router = injector.get(Router);
  }

  ngOnInit(): void {
    this.getRoles()
    this.setScheduledPayoutDate()
    this.getPayoutStatements()
  }

  setScheduledPayoutDate(): void {
    const now = new Date()
    let date: number = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)

    if (now.getDate() > 2) {
      date = Date.UTC(now.getFullYear(), now.getMonth() + 1, now.getDate(), 0, 0, 0, 0)
    }

    this.scheduledPayoutDate = new Date(date)
  }

  async getPayoutStatements() {
    if (this.isOperator) {
      const customerId = this.activatedRoute.firstChild.snapshot.params.key;
      if (customerId == null) {
        this.toastService.error(`Auszahlungsbelege konnten nicht geladen werden.`, 0, true)
      } else {
        this.payoutStatementsService.getCustomerPayoutStatementsAsTableData(customerId).subscribe(payoutStatements => {
          this.payoutStatements = payoutStatements
        }, error => console.error(error))
      }
    } else {
      this.payoutStatementsService.getPayoutStatementsAsTableData().subscribe(payoutStatements => {
        this.payoutStatements = payoutStatements
      }, error => console.error(error))
    }
  }
  
  async download(payoutStatement: PayoutStatementTableData) {
    this.toastService.loading('Auszahlungsbeleg wird heruntergeladen...')
    this.payoutStatementsService.downloadPayoutStatement(payoutStatement.id).subscribe((response: any) => {
      const file = new Blob([response], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(file);
      const fileName = `${payoutStatement.documentNumber}.pdf`

      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = fileUrl;
      a.download = fileName;
      a.click();

      window.URL.revokeObjectURL(fileUrl);
      this.toastService.success('Auszahlungsbeleg erfolgreich heruntergeladen.', 0, true)
    },
    error => {
      console.error(error);
      this.toastService.error(`Auszahlungsbeleg konnte nicht heruntergeladen werden.`, 0, true)
    })
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
  }
}